import { render } from "./mall.vue?vue&type=template&id=284d42ef&scoped=true"
import script from "./mall.vue?vue&type=script&lang=js"
export * from "./mall.vue?vue&type=script&lang=js"

import "./mall.vue?vue&type=style&index=0&id=284d42ef&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-284d42ef"]])

export default __exports__